export default __webpack_public_path__ + "static/media/enter-background.8dde3df8.png";